import { __ } from '@wordpress/i18n';
import { useState } from 'react';
import { RangeControl, __experimentalToggleGroupControl as ToggleGroupControl,
  __experimentalToggleGroupControlOptionIcon as ToggleGroupControlOptionIcon, } from '@wordpress/components';
import {
	arrowRight,
	arrowLeft,
	justifyCenter,
	justifySpaceBetween,
	moreVertical,
	notAllowed,
	justifyTop,  
	justifyBottom, 
	justifyCenterVertical, 
	justifyStretchVertical
} from '@wordpress/icons';
import {   } from '@wordpress/icons';
import { VayuBlocksDeviceControl,VayuBlocksDevice  } from '@vayu-blocks/device-control';

// "flex":{
//   "type":"object",
//   "default":{
//     "alignself":{"Desktop":"","Tablet":"","Mobile":""},
//     "order":{"Desktop":"","Tablet":"","Mobile":""},
//     "customorder":{"Desktop":0,"Tablet":0,"Mobile":0},
//     "size":{"Desktop":"","Tablet":"","Mobile":""},
//     "flexgrow":{"Desktop":0,"Tablet":0,"Mobile":0},
//     "flexshrink":{"Desktop":0,"Tablet":0,"Mobile":0}
//   }
// },

export const VayuBlocksFlexPanel = ({ onChange, flex={} }) => {

	const getView = VayuBlocksDevice() || 'Desktop';
	
	const [firstDesktop, setFirstDesktop] = useState(false);
	const [firstTablet, setFirstTablet] = useState(false); 

	const defaults = {
		Desktop: '',
		Tablet: '',
		Mobile: ''
	};
	
	const numberDefaults = {
		Desktop: 0,
		Tablet: 0,
		Mobile: 0
	};
	
	const {
		alignself = defaults,
		order = defaults,
		customorder = numberDefaults,
		size = defaults,
		flexgrow = numberDefaults,
		flexshrink = numberDefaults
	} = flex?.value || {};
	
	const getSelfAlign = () => alignself?.[getView];
	const getOrder = () => order?.[getView];
	const getCustomOrder = () => customorder?.[getView];
	const getSize = () => size?.[getView];
	const getFlexGrowSize = () => flexgrow?.[getView];
	const getFlexShrinkSize = () => flexshrink?.[getView];

	const customTooltip = (value) => `${value}`;

	const updateFlexValue = (keyName, newVal) => {
		
		const attr = keyName;

		const updatedAttributes = {
		  ...flex.value,
		  [keyName]: {
			  ...flex.value?.[keyName],
			  [getView]: newVal,
		  },
		};

		const isFirstRun = attr?.[getView] === undefined;
		const isTabletFirstRun = localStorage.getItem('firstTablet') || firstTablet;
  
		if (getView === 'Desktop') {
		  if (isFirstRun || firstDesktop) {
			  Object.assign(updatedAttributes[keyName], { Tablet: newVal, Mobile: newVal });
			  localStorage.setItem('firstTablet', 'true');
			  setFirstTablet(true);
			  setFirstDesktop(true);
		  }
		} else if (getView === 'Tablet') {
			if (isTabletFirstRun) {
				Object.assign(updatedAttributes[keyName], { Mobile: newVal});
				localStorage.removeItem('firstTablet');
				setFirstTablet(true);
				setFirstDesktop(false);
			}
		} else {
			setFirstTablet(false);
			setFirstDesktop(false);
		}
    
       onChange(flex.key, updatedAttributes);
	};

	return (
		<>

			<span> {<VayuBlocksDeviceControl label={__('Flex Child', 'vayu-blocks')} classname='bold'/>}</span>
			<div className="vb-toogle-icon-position alignment-component-vb">
				<ToggleGroupControl
					__next40pxDefaultSize={true}
					className="vb-toogle-icon-position-border"
					isDeselectable
					__nextHasNoMarginBottom={true}
					label={__('Align Self', 'vayu-blocks')}
					value={getSelfAlign()}
					onChange={(value) => updateFlexValue('alignself', value)}
				>
					<ToggleGroupControlOptionIcon icon={justifyTop} label={__('Start', 'vayu-blocks')} value="start" />
					<ToggleGroupControlOptionIcon icon={justifyCenterVertical} label={__('Center', 'vayu-blocks')} value="center" />
					<ToggleGroupControlOptionIcon icon={justifyBottom} label={__('End', 'vayu-blocks')} value="end" />
					<ToggleGroupControlOptionIcon icon={justifyStretchVertical} label={__('Stretch', 'vayu-blocks')} value="stretch" />
				</ToggleGroupControl>
			</div>

			<br/>

			<div className="vb-toogle-icon-position alignment-component-vb">
				
				<ToggleGroupControl
					__next40pxDefaultSize={true}
					__nextHasNoMarginBottom={true}
					className="vb-toogle-icon-position-border"
					label={__('Size', 'vayu-blocks')}
					value={getSize()}
					onChange={(value) => updateFlexValue('size', value)}
					isDeselectable
				>
					<ToggleGroupControlOptionIcon icon={notAllowed} label={__('None', 'vayu-blocks')} value="none" />
					<ToggleGroupControlOptionIcon icon={justifySpaceBetween} label={__('Grow', 'vayu-blocks')} value="grow" />
					<ToggleGroupControlOptionIcon icon={justifyCenter} label={__('Shrink', 'vayu-blocks')} value="shrink" />
					<ToggleGroupControlOptionIcon icon={moreVertical} label={__('Custom', 'vayu-blocks')} value="custom" />
				</ToggleGroupControl>

			</div>
			<br/>
			{ flex?.value?.size?.[getView] === 'custom' && (
				<>
					<RangeControl
						__next40pxDefaultSize={true}
						__nextHasNoMarginBottom={true}
						renderTooltipContent={customTooltip}
						value={getFlexGrowSize() ?? ''}
						label={__('Flex Grow', 'vayu-blocks')}
						onChange={(value) => updateFlexValue('flexgrow', value)}
						min={0}
						max={5}
						showTooltip={true}
						marks	
						allowReset={true}
						withInputField={false}
					/>
					<RangeControl
						__next40pxDefaultSize={true}
						__nextHasNoMarginBottom={true}
						value={getFlexShrinkSize() ?? ''}
						label={__('Flex Shrink', 'vayu-blocks')}
						onChange={(value) => updateFlexValue('flexshrink', value)} 
						min={0}
						max={5}
						showTooltip={true}
						marks	
						allowReset={true}
						withInputField={false}
					/>
				</>
			)}

			<div className="vb-toogle-icon-position alignment-component-vb">
				
				<ToggleGroupControl
					__next40pxDefaultSize={true}
					__nextHasNoMarginBottom={true}
					label={__('Order', 'vayu-blocks')}
					className="vb-toogle-icon-position-border"
					value={getOrder()}
					onChange={(value) => updateFlexValue('order', value)}
				>
					<ToggleGroupControlOptionIcon icon={arrowLeft} label={__('Start', 'vayu-blocks')} value="start" />
					<ToggleGroupControlOptionIcon icon={arrowRight} label={__('End', 'vayu-blocks')} value="end" />
					<ToggleGroupControlOptionIcon icon={moreVertical} label={__('Custom', 'vayu-blocks')} value="custom" />
					
				</ToggleGroupControl>

			</div>

			<br/>

			{flex?.value?.order?.[getView] === 'custom' && (
				<RangeControl
				__next40pxDefaultSize={true}
				__nextHasNoMarginBottom={true}
					label={__('Custom Order', 'vayu-blocks')}
					renderTooltipContent={customTooltip}
					value={getCustomOrder() ?? ''}
					onChange={(value) => updateFlexValue('customorder', value)}
					min={0}
					max={20}
					step={1}
					showTooltip={true}
					allowReset={true}
					withInputField={false}
				/>
			)}
		</>
	);
};